import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { describeLoadFailure, jsonOrThrow } from '../apiJson';
import { shouldSubmitSearch } from '../searchSubmit';
import { LogoMark } from './LogoMark';
import { SearchField } from './SearchField';
import { SearchStatsLine } from './SearchStatsLine';
import { CategoryList } from './CategoryList';
import { SiteFooter } from './SiteFooter';
import { PageHead } from './PageHead';
import { DEFAULT_DESCRIPTION, HOME_WEBSITE_JSON_LD } from '../seo';
import './LandingPage.css';

export function LandingPage() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [comingSoonCategories, setComingSoonCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [categoriesError, setCategoriesError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch('/api/landing-categories.php')
      .then((res) => jsonOrThrow(res))
      .then((data) => {
        if (!cancelled) {
          setCategories(Array.isArray(data?.categories) ? data.categories : []);
          setComingSoonCategories(
            Array.isArray(data?.comingSoonCategories)
              ? data.comingSoonCategories
              : [],
          );
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setCategoriesError(describeLoadFailure(e));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setCategoriesLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  function goToSearch(query) {
    const trimmed = typeof query === 'string' ? query.trim() : '';
    if (!shouldSubmitSearch(trimmed)) {
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  }

  const footerCategories = [...categories, ...comingSoonCategories];

  return (
    <>
      <PageHead
        title="Compare products from online shops in Malta | Shops.mt"
        description={DEFAULT_DESCRIPTION}
        canonicalPath="/"
        jsonLd={HOME_WEBSITE_JSON_LD}
      />
      <main className="landing">
        <div className="landing__stack">
          <div className="landing__logo-wrap">
            <LogoMark />
            <p className="landing__since">since 2026</p>
          </div>
          <SearchField onSubmitSearch={goToSearch} gaSearchLocation="home" />
          <h1 className="landing__seo-title">
            Compare products from online shops in Malta
          </h1>
          <SearchStatsLine />
        </div>
        <CategoryList
          categories={categories}
          comingSoonCategories={comingSoonCategories}
          categoriesLoading={categoriesLoading}
          errorMessage={categoriesError}
        />
      </main>
      <SiteFooter browseCategories={footerCategories} />
    </>
  );
}
